import React from "react";
import TopGallery from "./TopGallery.jsx";

import "./Header.css";

import logoImage from "../../../res/CI/text-path.svg";

export default class Header extends React.Component
{
    render () {
        return (
            <header>
                <div>
                    <img src={logoImage} alt="Risag e.U." />
                </div>

                <div>
                    Ihr Spezialist in Sachen Edelstahl.
                    <br />
                    Ihre Messerschleiferei und Scherenschleiferei in Feldkirch.
                </div>

                <TopGallery />
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Header.jsx